import React from 'react';

const IconEmptyStrategies = () => (
  <svg
    width="116"
    height="84"
    viewBox="0 0 116 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18107_522662)">
      <circle cx="60.8233" cy="41.9991" r="38.917" fill="#F4F7FA" />
      <g clipPath="url(#clip1_18107_522662)">
        <g filter="url(#filter0_f_18107_522662)">
          <rect
            x="35.0859"
            y="29.4277"
            width="70.283"
            height="47.0489"
            rx="4.64681"
            transform="rotate(-5.83338 35.0859 29.4277)"
            fill="#3E485B"
            fillOpacity="0.1"
          />
        </g>
        <g filter="url(#filter1_f_18107_522662)">
          <rect
            x="15.3125"
            y="-0.0585938"
            width="69.3462"
            height="40.7904"
            rx="4.64681"
            transform="rotate(13.7241 15.3125 -0.0585938)"
            fill="#3E485B"
            fillOpacity="0.1"
          />
        </g>
      </g>
      <g filter="url(#filter2_d_18107_522662)">
        <rect
          x="18.2266"
          y="0.179688"
          width="62.3472"
          height="36.3341"
          rx="4.64681"
          transform="rotate(12.1445 18.2266 0.179688)"
          fill="white"
        />
        <rect
          x="18.4494"
          y="0.524713"
          width="61.7664"
          height="35.7532"
          rx="4.35638"
          transform="rotate(12.1445 18.4494 0.524713)"
          stroke="url(#paint0_linear_18107_522662)"
          strokeWidth="0.580851"
        />
      </g>
      <rect
        opacity="0.7"
        x="23.0234"
        y="9.17578"
        width="25.7345"
        height="3.89294"
        rx="1.94647"
        transform="rotate(12.1445 23.0234 9.17578)"
        fill="#E0E7F1"
      />
      <rect
        opacity="0.7"
        x="20.5234"
        y="19.0488"
        width="45.1621"
        height="2.59529"
        rx="1.29765"
        transform="rotate(12.1445 20.5234 19.0488)"
        fill="#F5F7F9"
      />
      <rect
        opacity="0.7"
        x="18.6797"
        y="26.8965"
        width="45.1621"
        height="2.59529"
        rx="1.29765"
        transform="rotate(12.1445 18.6797 26.8965)"
        fill="#F5F7F9"
      />
      <rect
        x="47.5625"
        y="30.3828"
        width="18.167"
        height="2.59529"
        rx="1.29765"
        transform="rotate(12.1445 47.5625 30.3828)"
        fill="#F5F7F9"
      />
      <g filter="url(#filter3_d_18107_522662)">
        <rect
          x="36.7227"
          y="30.7129"
          width="69.1006"
          height="41.1663"
          rx="5.26481"
          transform="rotate(-6.06479 36.7227 30.7129)"
          fill="white"
        />
        <rect
          x="37.0846"
          y="31.0053"
          width="68.4425"
          height="40.5082"
          rx="4.93576"
          transform="rotate(-6.06479 37.0846 31.0053)"
          stroke="url(#paint1_linear_18107_522662)"
          strokeWidth="0.658101"
        />
      </g>
      <rect
        x="45.0117"
        y="38.1855"
        width="29.0772"
        height="4.41068"
        rx="2.20534"
        transform="rotate(-6.06479 45.0117 38.1855)"
        fill="#E0E7F1"
      />
      <rect
        x="45.5312"
        y="47.7598"
        width="32.6044"
        height="2.94045"
        rx="1.47023"
        transform="rotate(-6.06479 45.5312 47.7598)"
        fill="#F1F4F9"
      />
      <rect
        x="46.6445"
        y="54.7168"
        width="35.7843"
        height="2.94045"
        rx="1.47023"
        transform="rotate(-6.06479 46.6445 54.7168)"
        fill="#F1F4F9"
      />
      <rect
        x="47.6562"
        y="61.6289"
        width="56.3791"
        height="2.94045"
        rx="1.47023"
        transform="rotate(-6.06479 47.6562 61.6289)"
        fill="#F1F4F9"
      />
      <circle
        cx="92.2766"
        cy="41.2118"
        r="10.3812"
        transform="rotate(-6 92.2766 41.2118)"
        fill="#F1F4F9"
      />
      <path
        d="M96.915 40.9563L97.1695 45.5961"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.9256 42.6735L94.0952 45.7648"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.7944 44.3652L87.8898 46.1051"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.76 42.2246L90.9636 45.9364"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M94.4484 39.0606C94.8665 39.4352 94.9017 40.0779 94.5271 40.496C94.1525 40.9141 93.5098 40.9494 93.0917 40.5747C92.6736 40.2001 92.6384 39.5575 93.013 39.1394C93.3876 38.7213 94.0303 38.686 94.4484 39.0606"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.4389 36.2769C97.857 36.6516 97.8923 37.2942 97.5176 37.7123C97.143 38.1304 96.5004 38.1657 96.0823 37.791C95.6642 37.4164 95.6289 36.7738 96.0035 36.3557C96.3781 35.9376 97.0208 35.9023 97.4389 36.2769"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.2092 39.9229C88.6273 40.2976 88.6625 40.9402 88.2879 41.3583C87.9133 41.7764 87.2707 41.8117 86.8525 41.437C86.4344 41.0624 86.3992 40.4198 86.7738 40.0017C87.1484 39.5836 87.7911 39.5483 88.2092 39.9229"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M91.2003 37.14C91.6184 37.5146 91.6537 38.1572 91.2791 38.5753C90.9044 38.9935 90.2618 39.0287 89.8437 38.6541C89.4256 38.2795 89.3903 37.6368 89.765 37.2187C90.1396 36.8006 90.7822 36.7653 91.2003 37.14"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96.0216 37.7244L94.5105 39.1278"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.8919 39.3039L91.3946 38.4146"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.2755 39.9933L89.7808 38.5902"
        stroke="#BFCDE1"
        strokeWidth="0.871276"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip2_18107_522662)">
        <path
          d="M16.8548 75.8721C14.892 69.7774 14.8762 56.4183 30.5151 51.7391"
          stroke="#ED4C5E"
          strokeWidth="1.04553"
          strokeLinecap="round"
          strokeDasharray="4.01 3.21"
        />
        <path
          d="M30.0703 54.3945L31.5702 51.3489L28.5246 49.849"
          stroke="#ED4C5E"
          strokeWidth="1.04553"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <circle cx="61.1217" cy="22.2526" r="9.29362" fill="#FD6778" />
      <path
        d="M61.1012 18.8848C61.7456 18.8848 62.2629 19.0613 62.6533 19.4145C63.0498 19.7615 63.2481 20.2416 63.2481 20.855C63.2481 21.4622 63.0529 21.9269 62.6626 22.2491C62.2722 22.565 61.7549 22.723 61.1105 22.723L61.0733 23.4386H59.9302L59.8838 21.8587H60.302C60.841 21.8587 61.2561 21.7875 61.5473 21.645C61.8385 21.5025 61.9841 21.2422 61.9841 20.8643C61.9841 20.5917 61.9036 20.3748 61.7425 20.2138C61.5876 20.0527 61.3738 19.9721 61.1012 19.9721C60.8162 19.9721 60.5932 20.0496 60.4321 20.2045C60.2772 20.3594 60.1997 20.5731 60.1997 20.8457H58.973C58.9668 20.4678 59.0473 20.1301 59.2146 19.8327C59.3819 19.5353 59.6266 19.303 59.9488 19.1357C60.2772 18.9684 60.6613 18.8848 61.1012 18.8848ZM60.4971 25.6598C60.2617 25.6598 60.0665 25.5886 59.9116 25.4461C59.7629 25.2974 59.6886 25.1146 59.6886 24.8977C59.6886 24.6809 59.7629 24.5012 59.9116 24.3587C60.0665 24.21 60.2617 24.1357 60.4971 24.1357C60.7264 24.1357 60.9154 24.21 61.0641 24.3587C61.2128 24.5012 61.2871 24.6809 61.2871 24.8977C61.2871 25.1146 61.2128 25.2974 61.0641 25.4461C60.9154 25.5886 60.7264 25.6598 60.4971 25.6598Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_18107_522662"
        x="19.27"
        y="6.46859"
        width="106.333"
        height="85.5804"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="8.13192"
          result="effect1_foregroundBlur_18107_522662"
        />
      </filter>
      <filter
        id="filter1_f_18107_522662"
        x="-9.66001"
        y="-15.3537"
        width="107.634"
        height="86.6683"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="8.13192"
          result="effect1_foregroundBlur_18107_522662"
        />
      </filter>
      <filter
        id="filter2_d_18107_522662"
        x="6.80848"
        y="-2.43286"
        width="78.4676"
        height="58.5094"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.1617" dy="2.3234" />
        <feGaussianBlur stdDeviation="2.90426" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_18107_522662"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_18107_522662"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_18107_522662"
        x="31.9842"
        y="19.9899"
        width="85.1725"
        height="60.3461"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.3162" dy="2.6324" />
        <feGaussianBlur stdDeviation="3.29051" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_18107_522662"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_18107_522662"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_18107_522662"
        x1="25.6489"
        y1="3.66479"
        x2="75.5684"
        y2="32.7824"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFF1F7" />
        <stop offset="1" stopColor="#E7E7E7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_18107_522662"
        x1="44.9489"
        y1="34.6615"
        x2="100.888"
        y2="66.5794"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFF1F7" />
        <stop offset="1" stopColor="#E7E7E7" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_18107_522662">
        <rect width="116" height="84" fill="white" />
      </clipPath>
      <clipPath id="clip1_18107_522662">
        <rect
          x="21.6172"
          y="3.08203"
          width="78.4149"
          height="78.4149"
          rx="39.2074"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_18107_522662">
        <rect
          width="25.5099"
          height="19.2844"
          fill="white"
          transform="matrix(0.958036 -0.286647 -0.286647 -0.958036 12.7617 72.8711)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconEmptyStrategies;
